import axios from "axios";
import apiConfig from "../../config/apiConfig";
import Cookies from "js-cookie";

const apiCall = async (url, method = "get", data = null) => {
	const headers = {
		Authorization: `Bearer ZjYxZTRjNjQtNTIzYi00NWI1LWFlNTMtMDg1MWNlZGFkZmMw`,
		"Content-Type": "application/json",
	};

	const axiosConfig = {
		method,
		headers,
	};

	axiosConfig.url = apiConfig.BASE_URL + url;

	if (data) {
		axiosConfig.data = data;
	}

	let response;
	try {
		response = await axios(axiosConfig);
		return response;
	} catch (error) {
		return error.response;
	}
};

export default apiCall;
